var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "7.4744mm",
    height: "7.4744mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 7474.4 7474.4",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2B2A29",
    fillRule: "nonzero",
    points: "7474.4,1785.9 7252.2,1785.9 7252.2,382.7 3894.5,3740.4 7252.2,7098 7252.2,5688.5 7474.4,5688.5 7474.4,7474.4 5688.5,7474.4 5688.5,7252.2 7092.2,7252.2 3737.4,3897.5 382.7,7252.2 1785.9,7252.2 1785.9,7474.4 -0,7474.4 -0,5688.5 222.2,5688.5 222.2,7098.5 3580.3,3740.4 222.2,382.3 222.2,1785.9 -0,1785.9 -0,0 1785.9,0 1785.9,222.2 376.4,222.2 3737.4,3583.2 7098.4,222.2 5688.5,222.2 5688.5,0 7474.4,0 "
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc37);
export default __webpack_public_path__ + "static/media/ic_3_7.bc160ebaa473b62bcc6ebeb9216b1c2d.svg";
export { ForwardRef as ReactComponent };